import { BrandInfo } from '@/apis/core/types';
import { SelectItem } from '@/types';
import { capitalize } from 'lodash-es';

export const remapTCRStatus = (status: string, shouldCapitalize = false) => {
  if (status) {
    const value = status === 'EXPIRED' ? 'DEACTIVATED' : status;
    return shouldCapitalize ? capitalize(value) : value;
  }
  return 'N/A';
};

export const getR3kStatus = (brand: BrandInfo) => {
  const { optionalAttributes } = brand;
  return optionalAttributes && optionalAttributes.russell3000
    ? 'True'
    : 'False';
};

export const getTaxExemptStatus = (brand: BrandInfo) => {
  const { optionalAttributes } = brand;
  if (optionalAttributes) {
    if (optionalAttributes.section527) {
      return '527';
    }
    if (optionalAttributes.taxExemptStatus) {
      return optionalAttributes.taxExemptStatus;
    }
  }
  return 'N/A';
};

export const formatTitleCase = (enumValue: string) => {
  if (!enumValue) return null;
  return enumValue
    ?.toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getCategoryName = (
  rejectionCategoryIds: string[],
  categories: SelectItem[]
) => {
  if (!rejectionCategoryIds.length) {
    return '';
  }

  const categoryMap = new Map(categories.map((cat) => [cat.value, cat.label]));

  return rejectionCategoryIds
    .map((id) => {
      const trimmedId = id.trim();
      return categoryMap.get(trimmedId) || trimmedId;
    })
    .join(', ');
};
